export default __webpack_public_path__ + "static/media/mena21.5337658f.jpg";